import { getFicheroIdFile } from "api/Fichero.service"
import Spinner from "common/components/Spinner"
import { useCallback, useEffect, useState } from "react"
import { PdfViewer } from "./PdfViewer"

function ColumnRight({ ficheroId }: { ficheroId?: string }) {
  const [pdf, setPdf] = useState<Blob>()
  const [loading, setLoading] = useState(false)
  const getBlob = useCallback(async (id: string) => {
    try {
      setLoading(true)
      const res: Blob = id ? await getFicheroIdFile(id) : new Blob()
      setPdf(res)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    ficheroId ? getBlob(ficheroId) : setPdf(undefined)
  }, [getBlob, ficheroId])

  return pdf ? (
    <PdfViewer pdfBlob={pdf} />
  ) : (
    <div className='tw-flex tw-justify-center tw-items-center tw-h-full tw-w-full tw-bg-slate-100 tw-rounded'>
      {loading && <Spinner />}
    </div>
  )
}

export default ColumnRight
